import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const FUELS = ["Benzina", "Diesel", "Elettrica", "Ibrida", "GPL", "Metano"];
export const GEARBOXES = ["Manuale", "Automatico"];

const Pick = ({ id, label, value, onChange, options }) => (
  <div className="space-y-1.5">
    <Label className="text-xs font-medium text-slate-500 uppercase tracking-wider">{label}</Label>
    <Select value={value || "tutti"} onValueChange={(v) => onChange(v === "tutti" ? "" : v)}>
      <SelectTrigger data-testid={id} className="bg-white"><SelectValue /></SelectTrigger>
      <SelectContent>
        <SelectItem value="tutti">Tutti</SelectItem>
        {options.map((o) => <SelectItem key={o.value ?? o} value={o.value ?? o}>{o.label ?? o}</SelectItem>)}
      </SelectContent>
    </Select>
  </div>
);

const Num = ({ id, label, value, onChange, placeholder }) => (
  <div className="space-y-1.5">
    <Label className="text-xs font-medium text-slate-500 uppercase tracking-wider">{label}</Label>
    <Input data-testid={id} type="number" min="0" value={value || ""} placeholder={placeholder} onChange={(e) => onChange(e.target.value)} className="bg-white" />
  </div>
);

export const Filters = ({ f, set, brands, onReset }) => (
  <div className="space-y-5" data-testid="filters-panel">
    <Pick id="filter-brand-select" label="Marca" value={f.brand} onChange={(v) => set("brand", v)} options={brands} />
    <Pick id="filter-fuel-type" label="Alimentazione" value={f.fuel} onChange={(v) => set("fuel", v)} options={FUELS} />
    <Pick id="filter-gearbox" label="Cambio" value={f.gearbox} onChange={(v) => set("gearbox", v)} options={GEARBOXES} />
    <Pick id="filter-seller-type" label="Tipo venditore" value={f.seller_type} onChange={(v) => set("seller_type", v)}
      options={[{ value: "privato", label: "Privato" }, { value: "rivenditore", label: "Rivenditore" }]} />
    <Pick id="filter-mode" label="Modalità acquisto" value={f.mode} onChange={(v) => set("mode", v)}
      options={[{ value: "fisso", label: "Solo Compra subito" }, { value: "offerte", label: "Accetta offerte" }]} />
    <div className="grid grid-cols-2 gap-3">
      <Num id="filter-price-min" label="Prezzo min" value={f.price_min} onChange={(v) => set("price_min", v)} placeholder="€" />
      <Num id="filter-price-max" label="Prezzo max" value={f.price_max} onChange={(v) => set("price_max", v)} placeholder="€" />
      <Num id="filter-year-min" label="Anno da" value={f.year_min} onChange={(v) => set("year_min", v)} placeholder="2015" />
      <Num id="filter-year-max" label="Anno a" value={f.year_max} onChange={(v) => set("year_max", v)} placeholder="2025" />
    </div>
    <Num id="filter-km-max" label="Chilometraggio max" value={f.km_max} onChange={(v) => set("km_max", v)} placeholder="km" />
    <div className="space-y-1.5">
      <Label className="text-xs font-medium text-slate-500 uppercase tracking-wider">Città</Label>
      <Input data-testid="filter-city" value={f.city || ""} onChange={(e) => set("city", e.target.value)} placeholder="Es. Milano" className="bg-white" />
    </div>
    <Button variant="outline" className="w-full rounded-full" onClick={onReset} data-testid="filter-reset-button">Azzera filtri</Button>
  </div>
);
